import React from 'react';
import { X } from 'lucide-react';
import { useContacts } from '../../hooks/useContacts';

interface ContactSelectorProps {
  selectedContacts: string[];
  onSelectContact: (contactId: string) => void;
  onRemoveContact: (contactId: string) => void;
}

export default function ContactSelector({ selectedContacts, onSelectContact, onRemoveContact }: ContactSelectorProps) {
  const { contacts, loading } = useContacts();
  const availableContacts = contacts.filter(c => !selectedContacts.includes(c.id));

  if (loading) return <div className="text-gray-400">Loading contacts...</div>;

  return (
    <div className="space-y-4">
      {/* Selected Contacts */}
      <div className="space-y-2">
        {selectedContacts.map(contactId => {
          const contact = contacts.find(c => c.id === contactId);
          if (!contact) return null;
          
          return (
            <div key={contact.id} className="flex items-center justify-between bg-dark-700 p-2 rounded-lg">
              <span>{contact.first_name} {contact.last_name}</span>
              <button
                onClick={() => onRemoveContact(contact.id)}
                className="text-gray-400 hover:text-red-500"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          );
        })}
      </div>

      {/* Contact Dropdown */}
      {availableContacts.length > 0 && (
        <select
          className="input w-full"
          onChange={(e) => onSelectContact(e.target.value)}
          value=""
        >
          <option value="">Add contact...</option>
          {availableContacts.map(contact => (
            <option key={contact.id} value={contact.id}>
              {contact.first_name} {contact.last_name}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}